import {caseInsensitiveSort} from "../common/Utils";
export const residentColumns = [
  {
    name: "Name of Payee",
    selector: (row) =>
      (`${row?.payeeFirstName ?? ""} ${row?.payeeLastName ?? ""}`.trim().toUpperCase() || "-"),
    sortable: true,
    center: true,
    sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.payeeFirstName ? row.payeeFirstName : row.payeeLastName ? row.payeeLastName : ""),
  },
  {
    name: "Status/Date",
    selector: (row) =>
      row.residentStatus != null
        ? row.residentStatus === "R"
          ? "R/" + row.achEDate
          : "D/" + row.achEDate
        : "",
    sortable: true,
    center: true
  },
  {
    name: "Created By",
    selector: (row) => row.userName,
    sortable: true,
    center: true,
    sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName :""),
  },
  {
    name: "Created Date",
    selector: (row) => row.achDate,
    wrap: true,
    center: true,
    sortable: true,
  }
];

export const exportResidentColumns = [
  {
    header: 'Payee First Name',
    key: 'payeeFirstName'
  },
  {
    header: 'Payee Last Name',
    key: 'payeeLastName'
  },
  {
    header: 'Status',
    key: 'residentStatus'
  },
  {
    header: 'Date',
    key: 'achEDate'
  },
  {
    header: 'Created By',
    key: 'userName'
  },  
  {
    header: 'Created Date',
    key:'achDate',
  }
];
